import { render } from "./EditableTranscription.vue?vue&type=template&id=31c79c1e&scoped=true&ts=true"
import script from "./EditableTranscription.vue?vue&type=script&lang=ts"
export * from "./EditableTranscription.vue?vue&type=script&lang=ts"

import "./EditableTranscription.vue?vue&type=style&index=0&id=31c79c1e&scoped=true&lang=css"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31c79c1e"]])

export default __exports__